// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"1ab14ffc","539":"85d5c94c","596":"257adb64","787":"f6c1a827","979":"8d2eca1d"}[chunkId] + ".chunk.js";
};